import script from "./boardWritePage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardWritePage.vue?vue&type=script&setup=true&lang=js"

import "./boardWritePage.vue?vue&type=style&index=0&id=e01d293a&lang=css"

const __exports__ = script;

export default __exports__